import { useState } from 'react';
import { BASE } from '../api/client';

/** Referencias de una toma. Varias por toma, pero siempre atadas a esa toma. */
export function SceneReferences({
  value,
  onChange,
}: {
  value: string[];
  onChange: (ids: string[]) => void;
}) {
  const [uploading, setUploading] = useState(false);

  const upload = async (files: FileList | null) => {
    if (!files?.length) return;
    setUploading(true);
    try {
      const ids: string[] = [];
      for (const file of Array.from(files)) {
        const fd = new FormData();
        fd.append('file', file);
        fd.append('kind', 'reference');
        const res = await fetch(`${BASE}/projects/__character-gallery/assets`, {
          method: 'POST',
          credentials: 'include',
          body: fd,
        });
        if (!res.ok) continue;
        const asset = (await res.json()) as { id: string };
        ids.push(asset.id);
      }
      onChange([...value, ...ids]);
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="flex flex-wrap items-center gap-2">
      <span className="text-xs text-neutral-500">Referencias de esta toma:</span>
      {value.map((id) => (
        <span key={id} className="relative">
          <img src={`${BASE}/assets/${id}/thumb`} alt="" className="h-12 w-12 rounded object-cover" />
          <button
            onClick={() => onChange(value.filter((x) => x !== id))}
            className="absolute -right-1 -top-1 rounded-full bg-neutral-900 px-1 text-xs text-neutral-400 hover:text-red-400"
          >
            ✕
          </button>
        </span>
      ))}
      <label className="cursor-pointer rounded bg-neutral-800 px-2 py-1 text-xs text-neutral-300 hover:bg-neutral-700">
        {uploading ? 'Subiendo…' : '+ Imagen'}
        <input type="file" accept="image/*" multiple hidden onChange={(e) => upload(e.target.files)} />
      </label>
    </div>
  );
}
